import React from "react"
import Banner from "../../containers/banner"
import About from "../../containers/about"
import Layout from "../../containers/layout";
import { Container, Row, Col } from 'reactstrap';
import { Titlespan2 } from '../../components/title/index';
import AfterBanner from '../../containers/after-banner';

const IndexPage = () => {
    return (
        <Layout>
            <Banner ChangeClass={'demo1'} title="Industry Sectors" body={(
                <>
                    <h3>Merchants</h3>
                    <p><a className="text-white" href="/sectors">Back to sectors</a></p>
                </>
            )}/>
            <AfterBanner size={9} title="" subtitle="Overview">
                <table className="table">
                    <tr>
                        <td>
                            <strong>MANAGE ORDERS</strong><br/>
                            Provide quick and efficient over-the-counter ordering to your customers
                        </td>
                        <td>
                            <strong>MANAGE PRODUCTS</strong><br/>
                            Add names, images, prices, group them into product categories and track availability
                        </td>
                        <td>
                            <strong>GENERATE INVOICES</strong><br/>
                            Create invoices with the ability to add products, customer details, and notes.
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <strong>PROCESS PAYMENTS</strong><br/>
                            Process card, cash, and wallet payments
                        </td>
                        <td>
                            <strong>INVENTORY LOOK UP</strong><br/>
                            Quickly find out what is available in the stock by just scanning or tapping on items in product catalogue.
                        </td>
                        <td>
                            <strong>PROMOTIONS &amp; REWARDS</strong><br/>
                            Integrate existing or start customizing your own loyalty and rewards system.
                        </td>
                    </tr>
                </table>

            </AfterBanner>
        </Layout>
    )
}

export default IndexPage
